import { defineStore } from 'pinia'

type LocationData = {
  country_code?: string
  ip?: string
  [key: string]: any
}

type State = { data: LocationData | null }

export const useLocationStore = defineStore('location', {
  state: (): State => ({ data: null }),
  actions: {
    async fetch() {
      if (this.data) return this.data

      try {
        const { data, error } = await useFetch<LocationData>('/api/location')

        if (error.value) {
          console.error('Error fetching location data:', error.value)
          return null
        }
        this.data = data.value

        return this.data
      } catch (error) {
        console.error('Error fetching location data:', error)
        return null
      }
    },
  },
})
